module.exports = __webpack_public_path__ + "static/c_6-2e82936645b0a92af63834e0ca524892.jpg";